/**
 * Централизованный модуль для работы с localStorage (безопасные обёртки).
 *
 * Foundation-версия EyeHub: только то, что нужно шеллу (LanguageDropdown и др.).
 * Все операции обёрнуты в try/catch — Safari private mode / отключённое
 * хранилище не должны ронять приложение.
 *
 * @module utils/storage
 */

import { logger } from './logger';

/**
 * Проверяет наличие ключа в localStorage.
 * @param {string} key
 * @returns {boolean}
 */
export function checkKey(key) {
  try {
    return localStorage.getItem(key) !== null;
  } catch (e) {
    return false;
  }
}

/**
 * Получает строковое значение из localStorage без JSON.parse.
 * @param {string} key
 * @param {string|null} defaultValue
 * @returns {string|null}
 */
export function getRaw(key, defaultValue = null) {
  try {
    const item = localStorage.getItem(key);
    return item !== null ? item : defaultValue;
  } catch (e) {
    logger.error(`Error getting ${key} from localStorage:`, e);
    return defaultValue;
  }
}

/**
 * Сохраняет строковое значение в localStorage без JSON.stringify.
 * @param {string} key
 * @param {string} value
 * @returns {boolean} true если успешно
 */
export function setRaw(key, value) {
  try {
    localStorage.setItem(key, value);
    return true;
  } catch (e) {
    if (e.name === 'QuotaExceededError') {
      logger.error('localStorage is full. Cannot save data.');
    } else {
      logger.error(`Error saving ${key} to localStorage:`, e);
    }
    return false;
  }
}

/**
 * Удаляет ключ из localStorage.
 * @param {string} key
 * @returns {boolean}
 */
export function removeItem(key) {
  try {
    localStorage.removeItem(key);
    return true;
  } catch (e) {
    logger.error(`Error removing ${key} from localStorage:`, e);
    return false;
  }
}

const storage = { checkKey, getRaw, setRaw, removeItem };
export default storage;
